import './util/loadSlideLib';
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import md5 from 'js-md5';
import 'swiper/css/swiper.css';

import 'viewerjs/dist/viewer.css'
import Viewer, { directive as viewerDirective } from 'v-viewer'

Vue.use(ViewUI);
Vue.use(ElementUI);
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999
  }
});

Vue.directive('viewer', viewerDirective({
  debug: true,
  defaultOptions: {
    zIndex: 9999
  }
}));

Vue.prototype.$md5 = md5;

Vue.config.productionTip = false;

const Bus = new Vue({
  methods: {
    emit(event: any, ...args: any[]) {
      this.$emit(event, ...args);
    },
    on(event: any, callback: any) {
      this.$on(event, callback);
    },
    off(event: any, callback: any | undefined) {
      this.$off(event, callback);
    }
  }
});

Vue.prototype.$bus = Bus;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
